<form [formGroup]="formGroup">
  <section class="row">
    <!-- General info -->
    <div class="field-wr col-12 col-sm-12 col-md-12 col-lg-5">
      <label data-testid="add-company-field-name" class="block text-sm" for="name">{{ 'SYSTEM_SETTINGS.COMPANY.NAME' | translate }} <i class="icon-required-field"></i></label>
      <input data-testid="add-company-name-input" type="text" formControlName="name" autocomplete="off">
    </div>

    <div class="field-wr col-12 col-sm-7 col-md-7 col-lg-4">
      <label data-testid="add-company-field-identifier" class="block text-sm" for="identifier">{{ 'SYSTEM_SETTINGS.COMPANY.IDENTIFIER' | translate }}</label>
      <input data-testid="add-company-identifier-input" type="text" formControlName="identifier" autocomplete="off" (input)="convertIdentifierToLowercase()" (blur)="trimIdentifier()">
      <div class="error-hint-wr">
        @if (identifierControl?.hasError('pattern')) {
          <small class="p-error" data-testid="company-identifier-spaces-error">{{ 'SYSTEM_SETTINGS.COMPANY.IDENTIFIER_SPACES_ERROR' | translate }}</small>
        }
      </div>
    </div>

    <div class="field-wr col-12 col-sm-5 col-md-5 col-lg-3">
      <label data-testid="add-company-field-currency"  class="block text-sm mb-2" for="currency">{{ 'SYSTEM_SETTINGS.COMPANY.CURRENCY' | translate }}</label>
      <app-custom-dropdown
        data-testid="add-company-currency-input"
        [options]="currencies"
        optionLabel="label"
        optionValue="value"
        [isMultiselect]="false"
        [showSelectionChips]="true"
        [showClear]="false"
        [showSearchbox]="false"
        [searchMode]="'local'"
        [pageSize]="10"
        placeholder="USD"
        formControlName="currency">
      </app-custom-dropdown>
    </div>
  </section>

  <!-- Links -->
  <section class="row">
    <div class="col-12 mb-2">
      <h3 data-testid="company-links" class="border-b pb-3">{{ 'SYSTEM_SETTINGS.COMPANY.LINKS' | translate }}</h3>
    </div>

    <div class="field-wr col-12 col-md-12">
      <label data-testid="add-company-field-website" class="block text-sm" for="website">{{ 'SYSTEM_SETTINGS.COMPANY.WEBSITE' | translate }}</label>

      <input data-testid="add-company-website-input" type="text" formControlName="website" autocomplete="off">
      @if ( formGroup.get('website')?.hasError('invalidUrl') && formGroup.get('website')?.dirty) {
        <small class="p-error">{{ 'SYSTEM_SETTINGS.COMPANY.INVALID_URL' | translate }}</small>
      }
    </div>

    <div class="field-wr col-12 col-md-6">
      <label data-testid="add-company-field-privacypolicylink" class="block text-sm" for="privacyPolicyLink">{{ 'SYSTEM_SETTINGS.COMPANY.PRIVACY_POLICY' | translate }}</label>
      <input data-testid="add-company-privacypolicylink-input" type="text" formControlName="privacyPolicyLink" autocomplete="off">
      @if ( formGroup.get('privacyPolicyLink')?.hasError('invalidUrl') && formGroup.get('privacyPolicyLink')?.dirty) {
        <small class="p-error">{{ 'SYSTEM_SETTINGS.COMPANY.INVALID_URL' | translate }}</small>
      }
    </div>

    <div class="field-wr col-12 col-md-6">
      <label data-testid="add-company-field-termsofuselink" class="block text-sm" for="termsOfUseLink">{{ 'SYSTEM_SETTINGS.COMPANY.TERMS_OF_USE' | translate }}</label>
      <input data-testid="add-company-termsofuselink-input" type="text" formControlName="termsOfUseLink" autocomplete="off">
      @if ( formGroup.get('termsOfUseLink')?.hasError('invalidUrl') && formGroup.get('termsOfUseLink')?.dirty) {
        <small class="p-error">{{ 'SYSTEM_SETTINGS.COMPANY.INVALID_URL' | translate }}</small>
      }
    </div>

    <!-- <div class="field-wr col-12 col-md-6">
    <label data-testid="add-company-field-brandprivacypolicylink" class="block text-sm" for="brandPrivacyPolicyLink">{{ 'SYSTEM_SETTINGS.COMPANY.BRAND_PRIVACY_POLICY' | translate }}</label>
    <input data-testid="add-company-brandprivacypolicylink-input" type="text" formControlName="brandPrivacyPolicyLink" autocomplete="off">
  </div>

  <div class="field-wr col-12 col-md-6">
    <label data-testid="add-company-field-brandtermsofuselink" class="block text-sm" for="brandTermsOfUseLink">{{ 'SYSTEM_SETTINGS.COMPANY.BRAND_TERMS_OF_USE' | translate }}</label>
    <input data-testid="add-company-brandtermsofuselink-input" type="text" formControlName="brandTermsOfUseLink"
      autocomplete="off">
  </div> -->

  <div class="field-wr col-12 col-md-6">
    <label data-testid="add-company-field-supportemail" class="block text-sm" for="supportEmail">{{ 'SYSTEM_SETTINGS.COMPANY.SUPPORT_EMAIL' | translate }}</label>
    <input data-testid="add-company-supportemail-input" type="email" formControlName="supportEmail" autocomplete="off">
  </div>

  <div class="field-wr col-12 col-md-6">
    <label data-testid="add-company-field-senderemail" class="block text-sm" for="notificationSenderEmail">{{ 'SYSTEM_SETTINGS.COMPANY.NOTIFICATION_EMAIL' | translate }}</label>
    <input data-testid="add-company-senderemail-input" type="email" formControlName="notificationSenderEmail" autocomplete="off">
  </div>

  <div class="field-wr col-12 col-md-6">
    <label data-testid="add-company-field-usermanual" class="block text-sm" for="userManualLink">{{ 'SYSTEM_SETTINGS.COMPANY.USER_MANUAL_LINK' | translate }}</label>
    <input data-testid="add-company-usermanual-input" type="text" formControlName="userManualLink"
      autocomplete="off">
    @if ( formGroup.get('userManualLink')?.hasError('invalidUrl') && formGroup.get('userManualLink')?.dirty) {
      <small class="p-error">{{ 'SYSTEM_SETTINGS.COMPANY.INVALID_URL' | translate }}</small>
    }
  </div>

  <div class="field-wr col-12 col-md-6">
    <label data-testid="add-company-field-support" class="block text-sm" for="supportLink">{{ 'SYSTEM_SETTINGS.COMPANY.SUPPORT_LINK' | translate }}</label>
    <input data-testid="add-company-support-input" type="text" formControlName="supportLink"
      autocomplete="off">
    @if ( formGroup.get('supportLink')?.hasError('invalidUrl') && formGroup.get('supportLink')?.dirty) {
      <small class="p-error">{{ 'SYSTEM_SETTINGS.COMPANY.INVALID_URL' | translate }}</small>
    }
  </div>
</section>

<!-- App Links -->
<section class="row">
  <div class="col-12 mb-2">
    <h3 data-testid="company-applinks" class="border-b pb-3">{{ 'SYSTEM_SETTINGS.COMPANY.APP_LINKS' | translate }}</h3>
  </div>

  <div class="field-wr col-12 col-md-6">
    <label data-testid="add-company-field-ioslink" class="block text-sm" for="iosDownloadLink">{{ 'SYSTEM_SETTINGS.COMPANY.IOS_DOWNLOAD' | translate }}</label>
    <input data-testid="add-company-ioslink-input" type="text" formControlName="iosDownloadLink" />
    @if ( formGroup.get('iosDownloadLink')?.hasError('invalidUrl') && formGroup.get('iosDownloadLink')?.dirty) {
      <small class="p-error">{{ 'SYSTEM_SETTINGS.COMPANY.INVALID_URL' | translate }}</small>
    }
  </div>

  <div class="field-wr col-12 col-md-6">
    <label data-testid="add-company-field-androidlink" class="block text-sm" for="androidDownloadLink">{{ 'SYSTEM_SETTINGS.COMPANY.ANDROID_DOWNLOAD' | translate }}</label>
    <input data-testid="add-company-androidlink-input" type="text" formControlName="androidDownloadLink" />
    @if ( formGroup.get('androidDownloadLink')?.hasError('invalidUrl') && formGroup.get('androidDownloadLink')?.dirty) {
      <small class="p-error">{{ 'SYSTEM_SETTINGS.COMPANY.INVALID_URL' | translate }}</small>
    }
  </div>
</section>

<hr class="w-full mb-1 mt-6 border-t">

<!-- Direct import -->
@if (disableIsPrepaired == false) {
  <section class="row">
    <div class="field-wr col-12 col-sm-6 col-md-6 col-lg-4 mt-4">
      <label data-testid="add-company-field-prepaired-warranty" class="block text-sm" for="isPrepaired">{{ 'SYSTEM_SETTINGS.COMPANY.IS_PREPAIRED' | translate
      }}</label>
      <label data-testid="add-company-prepaired-warranty-yes-label" class="inline-flex mr-3">
        <p-radioButton data-testid="add-company-prepaired-warranty-yes" name="isPrepaired" value="true" formControlName="isPrepaired" inputId="prepaired-yes" />
        <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
      </label>
      <label data-testid="add-company-prepaired-warranty-no-label" class="inline-flex mr-1">
        <p-radioButton data-testid="add-company-prepaired-warranty-no" name="isPrepaired" value="false" formControlName="isPrepaired" inputId="prepaired-no" />
        <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
      </label>
    </div>
  </section>
}


</form>
